import { observable, action } from 'mobx'

export default class RealtimeChallenge {
  @observable answer = ''
  @observable image = null

  constructor ({ challenge }) {
    Object.assign(this, challenge)
  }

  @action setAnswer (answer) {
    this.answer = answer
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/RealtimeChallenge/Challenge.js